'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var IconButton = styled__default['default'].button.attrs(function (props) {
    var _a;
    return ({
        type: (_a = props.type) !== null && _a !== void 0 ? _a : 'button',
    });
}).withConfig({ displayName: "ww-uikit_IconButton_l8d1958d", componentId: "sc-um16at" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    width: 48px;\n    height: 48px;\n    display: grid;\n    place-items: center;\n    transition: 0.3s ease-out box-shadow;\n    box-shadow: inset 0 0 0 0 currentColor;\n    &:focus-visible {\n        box-shadow: inset 0 0 0 2px currentColor;\n    }\n"], ["\n    width: 48px;\n    height: 48px;\n    display: grid;\n    place-items: center;\n    transition: 0.3s ease-out box-shadow;\n    box-shadow: inset 0 0 0 0 currentColor;\n    &:focus-visible {\n        box-shadow: inset 0 0 0 2px currentColor;\n    }\n"])));
var templateObject_1;

exports.default = IconButton;
//# sourceMappingURL=index.js.map
